import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import React from 'react';
import SingleItem from '../singleItem/SingleItem';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const QuizOptions = ({ options }) => {
  const option = options.options
  const { correctAnswer, question , index} = options
  console.log(index)
 
  const Question = question.slice(3,-4)

  const eyeHandler = () => {
    toast(correctAnswer,  {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });

  }

  // const {id, question, correctAnswer} =options

  return (

    <div className=''>
      <div className='grid lg:grid-flow-cols-2 md:grid-cols-1  '>
        <h1 className=' text-center mt-10 p-4 text-xl'>Quiz : {Question}</h1>
        <button className='pr-10 grid justify-items-center' onClick={eyeHandler}><FontAwesomeIcon icon={faEye}></FontAwesomeIcon></button>

      </div>
      <div className=' lg:p-5 grid md:grid-cols-1 lg:grid-cols-2 sm:grid-cols-1 align-center bg-gray-300 lg:mx-32 md:mx-4 sm:mx-2justify-center'>
        {
          option.map(singleItem => <SingleItem singleItem={singleItem} correctAnswer={correctAnswer}></SingleItem>)
        }
        <ToastContainer
          position="top-center"
          autoClose={2000}

          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </div>
  );
};

export default QuizOptions;